"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPersonExercising = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M18.5 7.99a2 2 0 11-4 0 2 2 0 014 0z' }),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M17.174 3.76a1 1 0 00-1.302-1.519c-2.826 2.426-4.448 4.394-6.43 7.766-1.164 1.982-2.143 4.694-2.822 6.86a60.444 60.444 0 00-1.093 3.902 1 1 0 00.742 1.204 1.01 1.01 0 001.205-.745c.304-1.267.665-2.521 1.055-3.763.176-.561.37-1.15.578-1.744l.832.362 2.667 5.348s.392.875 1.336.448c.87-.394.47-1.297.47-1.297l-2.629-5.216 4.51-1.717a1 1 0 00.38-1.613l-3.06-3.311a1 1 0 01-.033-1.32l.307-.368c.935-1.13 1.966-2.144 3.287-3.278zm-4.315 9.068l.584-1.279.75.794-1.334.485z' }))); };
exports.default = SvgPersonExercising;
//# sourceMappingURL=PersonExercising.js.map